<template>
    <span v-if="parseInt(messageCount) > 0" class="badge" :class="classes">
        {{ messageCount }}
    </span>
</template>

<script>
import axios from 'axios';

export default {
    name: "UnreadMessagesCount",
    props: {
        count: {
            type: Number,
            required: true
        },
        conversation: {
            type: Object,
            required: true
        },
        classes: {
            type: String
        }
    },
    data: function () {
        return {
            messageCount: this.count,
        }
    },
    mounted() {
        window.Echo.private('conversations.' + this.conversation.id + '.' + window.Laravel.user.id)
            .listen('.messages.read', (e) => {
                this.getUnreadMessagesCount();
            });

        window.Echo.private('messages.' + this.conversation.id + '.' + window.Laravel.user.id)
            .listen('.message.created', (e) => {
                this.getUnreadMessagesCount();
            })
    },
    methods: {
        getUnreadMessagesCount() {
            axios.get(`/messages/unread-count`).then(result => {
                this.messageCount = result.data.count;
            }).catch(error => {
                console.log(error);
            })
        }
    }
}
</script>
